<template>
  <div>
    <h4 v-if="!canProducer($store.state.connections.current)">
      <small v-if="markets.length > 0 && markets.length < 2"
        ><strong> {{ markets[0].market.role.name }}</strong>
        {{ $t("family.dashboard.map.ctaSingular") }}
      </small>
      <small v-if="markets.length > 1"
        ><strong>{{
          markets.length === 2
            ? markets
                .map((m) => m.market.role.name)
                .join(` ${$t("family.dashboard.map.and")} `)
            : markets
                .map((m) => m.market.role.name)
                .slice(0, -1)
                .join(", ") +
              ` ${$t("family.dashboard.map.and")} ` +
              markets[markets.length - 1].market.role.name
        }}</strong>
        {{ $t("family.dashboard.map.ctaPlural") }}
      </small>
    </h4>
    <CRow class="mt-2 mb-0">
      <CCol
        v-if="!canProducer($store.state.connections.current)"
        sm="12"
        md="10"
        class="mb-3"
        style="height: 35vh"
      >
        <CCard class="rounded-top overflow-hidden" v-if="addressData">
          <LMap
            ref="map"
            :zoom="10"
            :options="{
              zoomControl: true,
              scrollWheelZoom: false,
              doubleClickZoom: true,
              touchZoom: true,
              dragging: true,
            }"
            :center="[addressData.lat, addressData.lng]"
            style="height: 35vh; width: 100%; z-index: 0"
          >
            <LTileLayer
              url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
              attribution='&copy; <a href="https://stamen.com">Stamen Design</a>, &copy; <a href="https://openstreetmap.org">OpenStreetMap</a>'
            />

            <!-- Green wavy lines from producers to family -->
            <LPolyline
              v-for="producerAddress in producerAddresses"
              :key="'line-' + producerAddress.lat + '-' + producerAddress.lng"
              :lat-lngs="
                generateWavyLine(
                  producerAddress.lat,
                  producerAddress.lng,
                  addressData.lat,
                  addressData.lng
                )
              "
              :color="'#90b44c'"
              :weight="2"
              :opacity="1"
            />

            <!--
            <LMarker
              v-for="marketAddress in marketAddresses"
              :key="marketAddress.lat"
              :lat-lng="[marketAddress.lat, marketAddress.lng]"
              :icon="marketMarkerIcon"
              :z-index-offset="100"
            />
            -->
            <LMarker
              v-for="producerAddress in producerAddresses"
              :key="'marker-' + producerAddress.lat + '-' + producerAddress.lng"
              :lat-lng="[producerAddress.lat, producerAddress.lng]"
              :icon="producerMarkerIcon"
              :z-index-offset="200"
            >
              <LTooltip :content="producerAddress.name" />
            </LMarker>
            <!--
            <LMarker
              v-for="islandAddress in islandAddresses"
              :key="'island-' + islandAddress.lat + '-' + islandAddress.lng"
              :lat-lng="[islandAddress.lat, islandAddress.lng]"
              :icon="islandMarkerIcon"
              :z-index-offset="300"
            />
            -->
            <LMarker
              :lat-lng="[addressData.lat, addressData.lng]"
              :icon="customMarkerIcon"
              :z-index-offset="1000"
            />
          </LMap>
        </CCard>
      </CCol>

      <CCol sm="12" md="10" class="mb-3" v-else>
        <CCard
          class="p-3"
          style="min-height: 35vh"
          v-if="canProducer($store.state.connections.current)"
        >
          <DashboardProducerTicker
            :isMarket="canMarket($store.state.connections.current)"
          />
        </CCard>
      </CCol>

      <CCol
        sm="12"
        md="2"
        class="mb-3"
        v-if="canProducer($store.state.connections.current)"
      >
        <CCard
          class="p-3"
          v-if="loonityNews.length > 0"
          style="min-height: 35vh"
        >
          <h4 class="mb-0">Loonity News 📰</h4>
          <hr />
          <div v-for="(item, index) in loonityNews" :key="item.id">
            <h6 class="mb-0">{{ item.title.rendered }}</h6>
            <small class="text-muted">{{ displayDate(item.date) }}</small>
            <p
              class="mb-0 mt-1 loonityNewsExcerpt"
              v-html="item.excerpt.rendered"
            ></p>
            <p>
              <a :href="item.link" target="_blank">{{
                $t("family.dashboard.news.read_more")
              }}</a>
            </p>
            <hr v-if="index < loonityNews.length - 1" />
          </div>
        </CCard>
        <CCard class="p-3" v-else style="min-height: 35vh">
          <h4>Loonity News 📰</h4>
          <hr />
          <div v-if="loonityNewsLoading">
            <div v-for="n in 4" :key="n" class="mb-3">
              <Skeleton width="80%" height="14px" class="mb-1" />
              <Skeleton width="40%" height="10px" class="mb-1" />
              <Skeleton width="100%" height="10px" class="mb-1" />
              <Skeleton width="60%" height="10px" />
              <hr v-if="n < 4" />
            </div>
          </div>
          <div v-else class="text-center">
            <span>{{ $t("family.dashboard.news.no_news") }}</span>
          </div>
        </CCard>
      </CCol>

      <CCol sm="12" md="2" class="mb-3" v-else>
        <CCard class="p-3 text-center" style="min-height: 35vh">
          <a href="https://www.loonity.com" target="_blank" class="w-100">
            <img
              src="/loonity/brand/LoonityLogoBlackSyg.png"
              alt="Family Location"
              class="mx-auto"
              style="width: 30px"
            />
          </a>
          <h5>{{ $t("family.dashboard.news.learn_more") }}</h5>
          <a href="https://www.loonity.com" target="_blank">loonity.com</a>
          <a href="https://www.loonity.com" target="_blank" class="w-100">
            <img
              src="/loonity/img/locationpin_family.png"
              alt="Family Location"
              class="mx-auto mt-2"
              style="width: 90%"
            />
          </a>
        </CCard>
      </CCol>
    </CRow>
    <hr class="mb-2" />
    <CRow class="mb-4">
      <DashboardFamilyMarket />
    </CRow>
    <CRow>
      <DashboardFamilyOrders />
    </CRow>
  </div>
</template>

<script>
import DashboardFamilyOrders from "./DashboardFamilyOrders.vue";
import DashboardFamilyMarket from "./DashboardFamilyMarket.vue";
import DashboardProducerTicker from "./partials/DashboardProducerTicker.vue";
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LPolyline,
  LTooltip,
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { CIcon } from "@coreui/icons-vue";
import { geocodeAddress } from "../../helpers/common";
import { apiGet, apiGetDirectUrl, apiPatch } from "../../helpers/apiHelper";
import { generateWavyLine, formatDate } from "../../helpers/common";
import { isActive, isProducer, isMarket } from "../../helpers/acl";
import Skeleton from "../../common/table/Skeleton.vue";

export default {
  data() {
    return {
      markets: [],
      producers: [],
      islands: [],
      addressData: null,
      marketAddresses: [],
      producerAddresses: [],
      islandAddresses: [],
      loading: false,
      loonityNewsLoading: true,
      loonityNews: [],
      customMarkerIcon: L.icon({
        iconUrl: "/loonity/img/locationpin_family.png",
        iconSize: [50, 50],
        iconAnchor: [25, 25],
      }),
      marketMarkerIcon: L.icon({
        iconUrl: "/loonity/img/locationpin_market.png",
        iconSize: [50, 50],
        iconAnchor: [25, 50],
      }),
      producerMarkerIcon: L.icon({
        iconUrl: "/loonity/img/locationpin_producer.png",
        iconSize: [50, 50],
        iconAnchor: [25, 25],
      }),
      islandMarkerIcon: L.icon({
        iconUrl: "/loonity/img/locationpin_island.png",
        iconSize: [50, 50],
        iconAnchor: [25, 25],
      }),
      iconSize: 64,
    };
  },

  methods: {
    generateWavyLine,
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    async fetchFamilyShippingAddress(familyId) {
      const response = await apiGet("auth_faddress", familyId);
      if (response && response.data) {
        const addresses = response.data.payload.Items;

        if (addresses.length > 0) {
          if (addresses[0].latitude && addresses[0].longitude) {
            this.addressData = {
              lat: parseFloat(addresses[0].latitude),
              lng: parseFloat(addresses[0].longitude),
            };
            return;
          }

          const geocodedAddress = await geocodeAddress(
            addresses.find((addr) => addr.default_ship === true)
          );

          if (geocodedAddress && geocodedAddress.lat && geocodedAddress.lng) {
            this.addressData = {
              lat: parseFloat(geocodedAddress.lat),
              lng: parseFloat(geocodedAddress.lng),
            };
          }
        }
      }
    },

    async fetchMarkets(familyId) {
      const response = await apiGet("family_markets", familyId);
      if (!response?.data) return;

      const markets = response.data.payload.Items.filter(
        (market) => market.market.mtype === 1
      );

      this.markets = markets;
      const marketAddresses = markets.map(
        (market) => market.market.role.family.addresses[0]
      );

      if (marketAddresses.length === 0) return;

      // Geocode sequentially with 1 second delay to respect rate limit
      const geocodedAddresses = [];
      for (const address of marketAddresses) {
        const geocodedAddress = await geocodeAddress(address);
        if (geocodedAddress) {
          geocodedAddresses.push({
            lat: parseFloat(geocodedAddress.lat),
            lng: parseFloat(geocodedAddress.lng),
          });
        }
        await this.delay(1000); // Wait 1 second between requests
      }

      this.marketAddresses = geocodedAddresses;
      this.loading = false;
      markets.forEach(async (market) => {
        await this.fetchIslands(market.market.id, familyId);
        await this.fetchProducers(market.market.id, familyId);
      });
    },

    async fetchProducers(marketId, familyId) {
      const response = await apiGet("family_market_producers", [
        familyId,
        marketId,
      ]);
      if (!response?.data) return;

      // Add only unique producers (check by producer ID)
      const newProducers = response.data.payload.Items.filter(
        (newProducer) =>
          !this.producers.some(
            (existingProducer) => existingProducer.id === newProducer.id
          )
      );
      this.producers.push(...newProducers);

      const producerAddresses = response.data.payload.Items.map((producer) => ({
        address: producer.role.family.addresses[0],
      }));

      if (producerAddresses.length === 0) return;

      for (const producer of producerAddresses) {
        const address = producer.address;

        // check if address already has lat and lng
        if (address.latitude && address.longitude) {
          const lat = parseFloat(address.latitude);
          const lng = parseFloat(address.longitude);

          // Check if this location is already in the array
          const isDuplicate = this.producerAddresses.some(
            (existing) => existing.lat === lat && existing.lng === lng
          );

          if (!isDuplicate) {
            this.producerAddresses.push({
              name: address.to,
              lat: lat,
              lng: lng,
            });
          }
          continue;
        }

        // get postal code
        const postal_code = await apiGet(
          "geo_postalcode",
          [],
          address.postal_code
        );
        if (postal_code?.data?.postal_code) {
          address.postal_code = parseInt(postal_code.data.postal_code);
          const geocodedAddress = await geocodeAddress(address);
          if (geocodedAddress) {
            const lat = parseFloat(geocodedAddress.lat);
            const lng = parseFloat(geocodedAddress.lng);

            // Check if this location is already in the array
            const isDuplicate = this.producerAddresses.some(
              (existing) => existing.lat === lat && existing.lng === lng
            );

            if (!isDuplicate) {
              this.producerAddresses.push({
                name: address.to,
                lat: lat,
                lng: lng,
              });
            }
          }
        }

        // rate limiting
        await this.delay(1000 / 5); // 5 requests per second
      }
    },

    async fetchIslands(marketId) {
      const response = await apiGet("role_marketisland", [marketId]);
      if (!response?.data) return;

      this.islands = response.data.payload.Items;
    },

    async fetchLoonityNews() {
      // Fetch blog posts from Loonity.com

      this.loonityNewsLoading = true;
      const postLang = this.$i18n.locale || "de";
      const response = await apiGetDirectUrl(
        `https://www.loonity.com/${postLang}/wp-json/wp/v2/posts?per_page=5`
      );

      if (response && response.data && response.status === 200) {
        console.log("Loonity News fetched successfully:", response);
        this.loonityNews = response.data;
      }
      this.loonityNewsLoading = false;
    },

    displayDate(postDate) {
      return postDate ? formatDate(new Date(postDate), "dd.MM.yyyy") : "";
    },

    canProducer(connection) {
      return isActive(connection) && isProducer(connection);
    },

    canMarket(connection) {
      return isActive(connection) && isMarket(connection);
    },
  },

  async created() {
    this.loading = true;
    await this.fetchFamilyShippingAddress([
      this.$store.state.connections.current.family.id,
    ]);
    if (this.canProducer(this.$store.state.connections.current)) {
      this.loading = false;
      return;
    }
    await this.fetchMarkets([this.$store.state.connections.current.family.id]);
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs.map && this.$refs.map.mapObject) {
        setTimeout(() => {
          this.$refs.map.mapObject.invalidateSize();
        }, 100);
      }
    });

    this.fetchLoonityNews();
  },

  computed: {
    currentFamilyId() {
      return this.$store.state.connections.current.family.id;
    },
  },

  watch: {
    async currentFamilyId(newId, oldId) {
      if (newId !== oldId) {
        // Reset all data
        this.markets = [];
        this.producers = [];
        this.islands = [];
        this.addressData = null;
        this.marketAddresses = [];
        this.producerAddresses = [];
        this.islandAddresses = [];

        // Reload map data
        this.loading = true;
        await this.fetchFamilyShippingAddress([newId]);
        await this.fetchMarkets([newId]);

        // Refresh map
        this.$nextTick(() => {
          if (this.$refs.map && this.$refs.map.mapObject) {
            setTimeout(() => {
              this.$refs.map.mapObject.invalidateSize();
            }, 100);
          }
        });
      }
    },
  },

  components: {
    DashboardFamilyOrders,
    DashboardFamilyMarket,
    DashboardProducerTicker,
    Skeleton,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPolyline,
    LTooltip,
    CIcon,
  },
};
</script>
